import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    name: '描述',
    textProp: 'arName',
    type: 'AR',
}
